import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

export default function liveQuery(queryString) {
    const query = gql`${queryString}`;
    return useQuery(query, {
        fetchPolicy: 'network-only'
    });
}
